import React, { createContext, useContext, useState } from 'react';

const TourPlayOptionsDialogContext = createContext({
    selectedTourId:null,
    selectedImageType:null,
    selectedDesignDate:null,
    selectedPanoDate:null,

    setSelectedTourId:null,
    setSelectedImageType:null,
    setSelectedDesignDate:null,
    setSelectedPanoDate:null,
});

function TourPlayOptionsDialogContextProvider(props) {

    const [ selectedTourId, setSelectedTourId ] = useState(0);
    const [ selectedImageType, setSelectedImageType ] = useState(0);

    const [ selectedPanoDate, setSelectedPanoDate ] = useState('');
    const [ selectedDesignDate, setSelectedDesignDate ] = useState('');

    return (
        <TourPlayOptionsDialogContext.Provider value={{
            selectedTourId,
            selectedImageType,
            selectedDesignDate,
            selectedPanoDate,

            setSelectedTourId,
            setSelectedImageType,
            setSelectedDesignDate,
            setSelectedPanoDate,
        }} {...props} />
    );
}

const useTourPlayOptionsDialogContextContext = () => useContext(TourPlayOptionsDialogContext);
export { useTourPlayOptionsDialogContextContext };
export { TourPlayOptionsDialogContextProvider };
export { TourPlayOptionsDialogContext };